// "Where to stay" links: the Stay22 link builders are shared
// (@todo/core/hotels — aid, centroids and map color from SITE.stay22); this
// file adds what only riviera has: the whole-coast map of the /[lang]/hotels
// page. On web, Stay22's map widget opens under the button on click
// (hotels-map.web.tsx); the one exception is the /[lang]/hotels page, whose
// whole-coast map loads with the page (HotelsMapPanel).

import type { Stay } from '@todo/core/hotels';

export { cityStay, eventStay, STAY22_SOURCE, stay22MapUrl, stay22Url, type Stay } from '@todo/core/hotels';

/**
 * The whole coast, Saint-Tropez to Menton: the /hotels page's default map,
 * centred on the Cap d'Antibes. Checked in a browser against the widget
 * (2026-10): a centre in the sea (the coast's true midpoint, ~43.52/7.06) — and
 * some points on land, e.g. Vallauris — make it fail with "We fell asleep",
 * and its `nelat`/`swlng`… bounds frame the wrong area, so it's a point and a
 * zoom. Zoom 9 fits the coast on a desktop-width map; a phone-width one needs 8.
 */
export const RIVIERA_STAY: Stay = { lat: 43.55, lng: 7.12 };
export const RIVIERA_ZOOM = 9;
export const RIVIERA_ZOOM_NARROW = 8;
